import axios from 'axios';
const ExtHttpLib = {
  ...axios,
  ...axios.create()
};
export { ExtHttpLib };